var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "world-map-container" },
    [
      _c(
        "world-map",
        _vm._g(_vm._b({}, "world-map", _vm.$attrs, false), _vm.$listeners)
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }